import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpRequest } from "@/lib";
import { RequestAgreementResponse } from "@/types";
import { PUT_AGREEMENT } from "./routes";

export type UpdateAgreementRequestDTO = {
  id: string;
  name: string;
  phone: string;
  commission: string;
};

async function updateAgreement(
  request: UpdateAgreementRequestDTO
): Promise<RequestAgreementResponse> {
  const { id, ...updateData } = request;

  const response = await httpRequest.put(
    PUT_AGREEMENT.replace(":id", id),
     updateData,
    );
  return response.data;
}

export function useUpdateAgreementMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateAgreement,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["agreements"] });
    },
  });
}
